<template>
  <div
    class="uploader"
    @dragover.prevent="onDragOver"
    @dragleave.prevent="onDragLeave"
    @drop.prevent="onDrop"
    :class="{ 'uploader--hover': isHovering }"
  >
    <!-- No image uploaded -->
    <div v-if="!preview">
      <span style="font-size: 48px;">☁️</span>
      <p class="text-gray-600">
        Drag & drop an image here, or
        <span class="upload-link" @click="openFileDialog">browse</span>
      </p>
    </div>

    <!-- Image preview -->
    <div v-else class="preview-wrapper">
      <img :src="preview" alt="Preview" class="preview" />
      <button class="delete-btn" @click="removeImage">❌ Remove</button>
    </div>

    <input
      ref="fileInput"
      type="file"
      accept="image/*"
      class="hidden"
      @change="onFileSelect"
    />
  </div>
</template>

<script setup>
import { ref, defineEmits } from 'vue'

const emit = defineEmits(['update:image'])

const isHovering = ref(false)
const preview = ref(null)
const fileInput = ref(null)

const onDragOver = () => (isHovering.value = true)
const onDragLeave = () => (isHovering.value = false)

const onDrop = (event) => {
  isHovering.value = false
  const file = event.dataTransfer.files[0]
  handleFile(file)
}

const onFileSelect = (event) => {
  const file = event.target.files[0]
  handleFile(file)
}

const handleFile = (file) => {
  if (!file || !file.type.startsWith('image/')) return
  const reader = new FileReader()
  reader.onload = (e) => {
    preview.value = e.target.result
    emit('update:image', file) // send file to parent
  }
  reader.readAsDataURL(file)
}

const openFileDialog = () => fileInput.value.click()

const removeImage = () => {
  preview.value = null
  fileInput.value.value = null
  emit('update:image', null) // notify parent the image was removed
}
</script>

<style scoped>
.uploader {
  border: 2px dashed #ccc;
  border-radius: 12px;
  padding: 2rem;
  text-align: center;
  transition: border-color 0.3s ease;
  cursor: pointer;
  position: relative;
  width: 100%;
}
.uploader--hover {
  border-color: #42a5f5;
  background-color: #f0f8ff;
}
.upload-link {
  color: #42a5f5;
  cursor: pointer;
  text-decoration: underline;
}
.preview-wrapper {
  position: relative;
  display: inline-block;
}
.preview {
  max-width: 100%;
  max-height: 250px;
  border-radius: 8px;
  object-fit: contain;
}
.delete-btn {
  position: absolute;
  top: 8px;
  right: 8px;
  background: rgba(255, 255, 255, 0.8);
  border: none;
  border-radius: 4px;
  cursor: pointer;
  padding: 4px 6px;
  font-size: 14px;
}
.hidden {
  display: none;
}
</style>
